export const BASE_URL = 'https://api.tint.tetraagroup.com'; //'http://10.1.1.10:8009'; //'https://api.tint.tetraagroup.com'; //'http://192.168.1.38:8009'; //


export const apiRequest = async (endpoint, method = 'GET', body = null, queryParams = {}) => {
  const token = localStorage.getItem('token');
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    //credentials: 'include',
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const url = new URL(`${BASE_URL}${endpoint}`);
  for (const [key, value] of Object.entries(queryParams)) {
    if (value !== null) {
      url.searchParams.append(key, value);
    }
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    if (response.status === 401) {
      // Token expired or invalid, logout the user
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    const errorData = await response.json();
    throw new Error(`Error: ${errorData.detail}`);
  }

  return await response.json();
}